import React from 'react';
import Stack from '@mui/material/Stack';
import {ContentBlockHeader} from '@growcloud-io/dc/components/surface/ContentBlockHeader';
import {newColumnStack,newRowStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";
import {nextId} from "@growcloud-io/gcio-commons/common/utils/IdUtils";
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';
import {CTAButton} from '@growcloud-io/dc/components/buttons/Buttons';
import {getCaseStudiesData,getResourcesData} from "./data/FrontPageData";
import {CaseStudies} from "@growcloud-io/gcio-commons/common/components/CaseStudies";

const caseStudiesData = getCaseStudiesData();
const resourcesData = getResourcesData()

const extractResources = (product,type) => {
  let resourcesArray = [];
  for (let resourceData of resourcesData) {
    if (resourceData.product === product && resourceData.type === type) {
      resourcesArray.push(resourceData);
    }
  }
  return resourcesArray;
}
export const ResourceItemTemplate = ({resourceData}) => {
  return (
    <Stack key={nextId()} direction={'column'} sx={newColumnStack()}>
      <Stack direction={'row'} key={nextId()} sx={newRowStack()}>
        <StarIcon style={{color:'gold'}}/>
        <Typography variant={'h4'} color="textSecondary">{resourceData.label}</Typography>
      </Stack>
      <Stack direction={'row'} key={nextId()} sx={newRowStack()}>
        <CTAButton
          buttonColor="primary"
          buttonText={'OPEN'}
          onClick={() => {
            window.location.href = `/resource/${resourceData.slug}`;
          }}
        />
      </Stack>
    </Stack>
  );
}

const renderItems = (items) => {
  let itemsArray = [];
  for (let item of items) {
    itemsArray.push((
      <ResourceItemTemplate key={nextId()} resourceData={item}/>
    ))
  }
  return itemsArray;
}

const ResourcesGroup = ({header,resourcesGroupData}) => {
  return (
    <Stack key={nextId()} direction={'column'} sx={newColumnStack()}>
      <Stack direction={'row'} key={nextId()} sx={newRowStack()}>
        <Typography variant={'h3'} color="textSecondary">{header}</Typography>
      </Stack>

      {resourcesGroupData && (
        <>
          {renderItems(resourcesGroupData)}
        </>
      )}

    </Stack>
  )
}

export const ResourcesPage = ({}) => {
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <ContentBlockHeader
        PageTitle={'RESOURCES'}
        SubHeader={''}
        Alignment="left"
      />
      <Stack direction={'column'} sx={newColumnStack()}>
        <ResourcesGroup
          header={'GC GUIDES'}
          resourcesGroupData={extractResources('AUTO','GUIDE')}
        />
      </Stack>

      <Stack direction={'column'} sx={newColumnStack()}>
        <ResourcesGroup
          header={'VENDORS GUIDES'}
          resourcesGroupData={extractResources('VENDORS','GUIDE')}/>
      </Stack>

      {/*<Stack direction={'column'} sx={newColumnStack()}>*/}
      {/*  <HeroPageItem heroItemData={{*/}
      {/*    "pageTitle":"RESOURCES BY TYPE",*/}
      {/*    "items":[*/}
      {/*      {label:'SCREENCASTS'},*/}
      {/*      {label:'GUIDES'},*/}
      {/*      {label:'HOWTOS'}*/}
      {/*    ],*/}
      {/*    "links":[]*/}
      {/*  }}/>*/}
      {/*</Stack>*/}

      <Stack direction={'column'} sx={newColumnStack()}>
        <CaseStudies caseStudiesData={caseStudiesData}/>
      </Stack>

    </Stack>
  );
}
